import { RouteConfig } from 'vue-router';
import applicationsRoutes from './applicationsRoutes';
import profileRoutes from './profileRoutes';
import providersDashboardRoutes from './providersDashboard';
import availabilityRoutes from './availabilityRoutes';

const providerRoutes = [
  ...applicationsRoutes,
  ...profileRoutes,
  ...providersDashboardRoutes,
  ...availabilityRoutes,
] as RouteConfig[];

export default providerRoutes;
